import { ReactNode } from 'react'

type Point = {
  id: string
  text: ReactNode
}

type GalleryItem = {
  id: string
  positive?: boolean
  points: Point[]
}

export const GALLERY_ITEMS: GalleryItem[] = [
  {
    id: 'Positive-gallery-item',
    positive: true,
    points: [
      {
        id: 'Positive-gallery-item-1',
        text: (
          <>
            <b>Business Owners and c-suite</b> executives who want to grow
            through genuine connections and meet other decision makers.
          </>
        ),
      },
      {
        id: 'Positive-gallery-item-2',
        text: (
          <>
            <b>Leaders and entrepreneurs</b> ready to expand their network and
            circle of influence.
          </>
        ),
      },
      {
        id: 'Positive-gallery-item-3',
        text: (
          <>
            <b>Elite, avid and beginner golfers</b> wanting to access
            Australia&#39;s most exclusive golf courses and play alongside PGA
            Pros to improve their game.
          </>
        ),
      },
      {
        id: 'Positive-gallery-item-4',
        text: (
          <>
            <b>Business professionals</b> who value relationships over
            transactional networking.
          </>
        ),
      },
    ],
  },
  {
    id: 'Negative-gallery-item',
    positive: false,
    points: [
      {
        id: 'Negative-gallery-item-1',
        text: (
          <>
            <b>Salespeople</b> just looking to pitch or spruik the room.
          </>
        ),
      },
      {
        id: 'Negative-gallery-item-2',
        text: (
          <>
            <b>People who don&#39;t like connecting</b> with others or opening
            their networks.
          </>
        ),
      },
      {
        id: 'Negative-gallery-item-3',
        text: (
          <>
            Anyone completely <b>disinterested in golf</b>.
          </>
        ),
      },
      {
        id: 'Negative-gallery-item-4',
        text: (
          <>
            Those <b>chasing quick wins</b> instead of building long term
            partnerships.
          </>
        ),
      },
    ],
  },
]
